import { render, staticRenderFns } from "./PerformanceImpactSection.vue?vue&type=template&id=f17e377a&scoped=true&"
import script from "./PerformanceImpactSection.vue?vue&type=script&lang=js&"
export * from "./PerformanceImpactSection.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceImpactSection.vue?vue&type=style&index=0&id=f17e377a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17e377a",
  null
  
)

export default component.exports